export const stockCheck = async (priceIds) => {
  if (priceIds.length == 0) {
    return []
  }

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ priceIds: priceIds })
  };

  const fetchUri = process.env.GATSBY_USE_TEST_FUNCTIONS == 'true'
    ? `${process.env.GATSBY_CLOUD_FUNCTIONS_URI}/stock-check-test`
    : `${process.env.GATSBY_CLOUD_FUNCTIONS_URI}/stock-check`

  const response = await fetch(fetchUri, requestOptions)

  if (!response.ok) {
    console.log('Error fetching stock levels')
    return 0
  }

  const productStocks = await response.json()
  return productStocks
}